import { render, staticRenderFns } from "./SelectMediaComponent.vue?vue&type=template&id=e08f99fe&scoped=true&"
import script from "./SelectMediaComponent.vue?vue&type=script&lang=js&"
export * from "./SelectMediaComponent.vue?vue&type=script&lang=js&"
import style0 from "./SelectMediaComponent.vue?vue&type=style&index=0&id=e08f99fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08f99fe",
  null
  
)

export default component.exports